var exports = {
  "kL": "FriendSelector.module__container___SFVITG",
  "hJ": "FriendSelector.module__searchField___SFVITG",
  "lA": "FriendSelector.module__searchFieldInner___SFVITG",
  "t$": "FriendSelector.module__selectedPill___SFVITG",
  "DT": "FriendSelector.module__removeButton___SFVITG",
  "qc": "FriendSelector.module__searchIcon___SFVITG",
  "D3": "FriendSelector.module__searchIconFocused___SFVITG",
  "Rt": "FriendSelector.module__searchInput___SFVITG",
  "XG": "FriendSelector.module__scroller___SFVITG",
  "yY": "FriendSelector.module__scrollerNoSearch___SFVITG",
  "p$": "FriendSelector.module__emptyState___SFVITG",
  "q6": "FriendSelector.module__emptyStateText___SFVITG",
  "_s": "FriendSelector.module__groupsContainer___SFVITG",
  "cp": "FriendSelector.module__groupLetter___SFVITG",
  "QS": "FriendSelector.module__friendsList___SFVITG",
  "jZ": "FriendSelector.module__friendButton___SFVITG",
  "An": "FriendSelector.module__friendButtonSelected___SFVITG",
  "FI": "FriendSelector.module__friendButtonDisabled___SFVITG",
  "Hb": "FriendSelector.module__friendInfo___SFVITG",
  "G3": "FriendSelector.module__friendName___SFVITG",
  "HI": "FriendSelector.module__checkboxContainer___SFVITG",
  "Yz": "FriendSelector.module__removeIcon___SFVITG",
};

module.exports = exports;
